// extracted by mini-css-extract-plugin
export default {"layout":"page_layout__N-lLO","form":"page_form__G1-ic","full-height":"page_full-height__5eEdd","body":"page_body__PaIh5","copyright":"page_copyright__KuNnW"};